import { Injectable } from '@angular/core';
import { ProxyService } from '@caslink/common-client/ng-app/proxy/ProxyService';
import { IModbusDeviceFirmwareVersion } from '../models/models';

@Injectable({
    providedIn: 'root'
})
export class FirmwareVersionService {
    public static $name: string = 'firmwareVersionService';

    public static $inject = [
        'proxyService'
    ];

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getList(deviceType: string): angular.IPromise<IModbusDeviceFirmwareVersion[]> {
        return this.proxyService.request({
            endPoint: this.getEndpointName(),
            queryParams: {
                deviceType: deviceType
            },
            route: 'getFirmwareVersions'
        }).asArray<IModbusDeviceFirmwareVersion>();
    }

    public getEndpointName() {
        return 'firmwareVersion';
    }
}
